import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    // Store original required state when controller connects
    this.storeOriginalRequiredState();
  }

  saveDraft(event) {
    // Remove required attributes from all form fields before submission
    this.removeRequiredAttributes();
  }

  submit(event) {
    // Ensure required attributes are restored for normal submission
    this.restoreRequiredAttributes();
  }

  storeOriginalRequiredState() {
    const form = this.formTarget;
    const allFields = form.querySelectorAll("input, select, textarea");

    allFields.forEach((field) => {
      if (field.hasAttribute("required")) {
        field.setAttribute("data-originally-required", "true");
      }
    });
  }

  removeRequiredAttributes() {
    const form = this.formTarget;
    const allFields = form.querySelectorAll(
      "input[required], select[required], textarea[required]"
    );

    allFields.forEach((field) => {
      field.removeAttribute("required");
    });
  }

  restoreRequiredAttributes() {
    const form = this.formTarget;
    const originallyRequiredFields = form.querySelectorAll(
      "[data-originally-required='true']"
    );

    originallyRequiredFields.forEach((field) => {
      field.setAttribute("required", "required");
    });
  }
}
